<template>
    <div class="app-layout">
        <!-- Navbar Start -->
        <header id="topnav" class="defaultscroll sticky">
            <div class="container">
                <!-- Logo container-->
                <a class="logo" href="/">
                    <span class="logo-light-mode">
                        <img :src="main?.settings?.logo" class="l-dark" height="24" alt="">
                        <img :src="main?.settings?.logo" class="l-light" height="24" alt="">
                    </span>
<!--                    <img src="assets/images/logo-light.png" height="24" class="logo-dark-mode" alt="">-->
                </a>

                <!-- End Logo container-->
                <div class="menu-extras">
                    <div class="menu-item">
                        <!-- Mobile menu toggle-->
                        <a class="navbar-toggle" id="isToggle" onclick="toggleMenu()">
                            <div class="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </a>
                        <!-- End mobile menu toggle-->
                    </div>
                </div>

                <!--Login button Start-->
                <ul class="buy-button list-inline mb-0" v-if=" ! auth.isLoggedIn()">
                    <li class="list-inline-item ps-1 mb-0">
                        <router-link :to="{ name:'login' }" class="pt-3">
                            <div class="login-btn-primary"><span class="btn btn-icon btn-pills btn-soft-primary"><i data-feather="log-in" class="fea icon-sm"></i></span></div>
                            <div class="login-btn-light"><span class="btn btn-icon btn-pills btn-light"><i data-feather="log-in" class="fea icon-sm"></i></span></div>
                        </router-link>
                    </li>
                </ul>

                <ul class="buy-button list-inline mb-0 buy-button list-inline mb-0 navigation-menu " :class="nav_type" v-if="auth.isLoggedIn()">
<!--                    <li class="list-inline-item mb-0">-->
<!--                        <a href="#">-->
<!--                        <span>-->
<!--                            Welcome : {{ auth.user('name') }}-->
<!--                        </span>-->
<!--                        </a>-->
<!--                    </li>-->

                    <li class="has-submenu parent-menu-item d-none d-lg-block">
                        <a href="javascript:void(0)"> Welcome : {{ auth.user('name') }} </a><span class="menu-arrow"></span>
                        <ul class="submenu">
                            <li class="product-box-contain" v-if=" ! auth.user('verified')" >
                                <i></i>
                                <router-link :to="{'name' : 'activation', }">
                                    Activate your membership
                                </router-link>
                            </li>
                            <li>
                                <router-link  :to="{ name:'subscriptions.index' }" class="sub-menu-item">
                                    My Courses
                                </router-link>
                            </li>
                            <li>
                                <router-link  :to="{ name:'users.edit' }" class="sub-menu-item">
                                    Edit My Information
                                </router-link>
                            </li>

                            <li>
                                <router-link  :to="{ name:'password.change' }" class="sub-menu-item">
                                    Change password
                                </router-link>
                            </li>

                            <li><a href="javascript:void(0)"  @click="auth.logout()" class="sub-menu-item">Log out</a></li>
                        </ul>
                    </li>

<!--                    <li class="list-inline-item mb-0">-->
<!--                        <a @click="auth.logout()" class="pt-3 px-0">-->
<!--                            <div class="login-btn-primary"><span class="btn btn-icon btn-pills btn-soft-primary"><i data-feather="log-out" class="fea icon-sm"></i></span></div>-->
<!--                            <div class="login-btn-light"><span class="btn btn-icon btn-pills btn-light"><i data-feather="log-out" class="fea icon-sm"></i></span></div>-->
<!--                        </a>-->
<!--                    </li>-->
                </ul>
                <!--Login button End-->

                <div id="navigation">
                    <!-- Navigation Menu-->
                    <ul class="navigation-menu " :class="nav_type" >
                        <li><a href="/" class="sub-menu-item">Home</a></li>

                        <li class="has-submenu parent-menu-item d-block d-lg-none">
                            <a href="javascript:void(0)"> Welcome : {{ auth.user('name') }} </a><span class="menu-arrow"></span>
                            <ul class="submenu">
                                <li>
                                    <router-link  :to="{ name:'subscriptions.index' }" class="sub-menu-item">
                                        My Courses
                                    </router-link>
                                </li>
                                <li>
                                    <router-link  :to="{ name:'users.edit' }" class="sub-menu-item">
                                        Edit My Information
                                    </router-link>
                                </li>

                                <li>
                                    <router-link  :to="{ name:'password.change' }" class="sub-menu-item">
                                        Change password
                                    </router-link>
                                </li>

                                <li><a href="javascript:void(0)"  @click="auth.logout()" class="sub-menu-item">Log out</a></li>
                            </ul>
                        </li>

                        <li v-for="page in main?.pages">
                            <router-link :to="{ name: 'pages.show', params: { id: page.id } }" class="sub-menu-item">
                                {{ page.title }}
                            </router-link>
                        </li>

                        <li class="has-submenu parent-menu-item">
                            <a href="javascript:void(0)">QBanks</a><span class="menu-arrow"></span>
                            <ul class="submenu">
                                <li v-for="course in main?.courses">
                                    <router-link :to="{ name: 'courses.show', params: { id: course.id } }" class="sub-menu-item">
                                        {{ course.name }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <router-link :to="{'name' : 'contact_us.create'}" class="sub-menu-item">
                                Contact us
                            </router-link>
                        </li>
                    </ul><!--end navigation menu-->
                </div><!--end navigation-->
            </div><!--end container-->
        </header><!--end header-->
        <!-- Navbar End -->

        <slot></slot> <!-- سيتم عرض محتويات Dashboard.vue هنا -->


        <section class="section pt-3" style="background: url('/assets/images/real/build.png') bottom no-repeat;" v-if="footer_image"></section>

        <!-- Footer Start -->
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="footer-py-60">
                            <div class="row">

                                <div class="col-lg-4 col-md-8 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 class="footer-head">QBanks</h5>
                                    <ul class="list-unstyled footer-list mt-4">
                                        <li v-for="course in main?.courses">
                                            <router-link :to="{ name: 'courses.show', params: { id: course.id } }" class="text-foot">
                                                <i class="uil uil-angle-right-b me-1"></i> {{ course.name }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div><!--end col-->

                                <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 class="footer-head">Usefull Links</h5>
                                    <ul class="list-unstyled footer-list mt-4">
                                        <li v-for="page in main?.pages">
                                            <router-link :to="{ name: 'pages.show', params: { id: page.id } }" class="text-foot">
                                                <i class="uil uil-angle-right-b me-1"></i> {{ page.title }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div><!--end col-->

                                <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                                    <a href="#" class="logo-footer d-flex justify-content-center">
                                        <img :src="main?.settings?.logo" class="l-dark" height="24" alt="">
                                    </a>
                                    <p class="mt-4">
                                        {{ main.settings?.about }}
                                    </p>

                                    <div class="mt-4" v-if="main.settings?.app_store_url || main.settings?.google_play_url ">
                                        <a :href="main.settings?.app_store_url" v-if="main.settings?.app_store_url">
                                            <img src="/assets/images/app/app.png" class="me-2" height="50" alt="">
                                        </a>

                                        <a :href="main.settings?.google_play_url" v-if="main.settings?.google_play_url">
                                            <img src="/assets/images/app/playstore.png" class="me-2" height="50" alt="">
                                        </a>
                                    </div>

                                    <ul class="list-unstyled social-icon foot-social-icon mb-0 mt-4">
                                        <li class="list-inline-item me-1" v-for="social_item in main?.social">
                                            <a :href="social_item.url" target="_blank" class="rounded">
                                                <!--                                                <i class="uil uil-shopping-cart align-middle" title="Buy Now"></i>-->
                                                <i :class="'fa-brands fa-' + social_item.type"></i>
                                            </a>
                                        </li>
                                    </ul><!--end icon-->


                                </div><!--end col-->
<!--                                <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">-->
<!--                                    <h5 class="footer-head">Newsletter</h5>-->
<!--                                    <p class="mt-4">Sign up and receive the latest tips via email.</p>-->
<!--                                    <form>-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-lg-12">-->
<!--                                                <div class="foot-subscribe mb-3">-->
<!--                                                    <label class="form-label">Write your email <span class="text-danger">*</span></label>-->
<!--                                                    <div class="form-icon position-relative">-->
<!--                                                        <i data-feather="mail" class="fea icon-sm icons"></i>-->
<!--                                                        <input type="email" name="email" id="emailsubscribe" class="form-control ps-5 rounded" placeholder="Your email : " required>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-lg-12">-->
<!--                                                <div class="d-grid">-->
<!--                                                    <input type="submit" id="submitsubscribe" name="send" class="btn btn-soft-primary" value="Subscribe">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </form>-->
<!--                                </div>&lt;!&ndash;end col&ndash;&gt;-->
                            </div><!--end row-->
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->

            <div class="footer-py-30 footer-bar">
                <div class="container text-center">
                    <div class="row align-items-center">
                        <div class="col-sm-6">
                            <div class="text-sm-start">
                                <p class="mb-0">
                                    © 2024
                                    {{ main.settings?.name }}. Design with <i class="mdi mdi-heart text-danger"></i>
                                    by <a href="https://imockup.net/" target="_blank" class="text-reset">مُكعبات</a>
                                </p>
                            </div>
                        </div><!--end col-->

                        <div class="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                            <div class="text-sm-end">
                                <p class="mb-0">
                                    All copy rights reserved © 2024
                                    {{ main.settings?.name }}
                                </p>
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
                </div><!--end container-->
            </div>
        </footer><!--end footer-->
        <!-- Footer End -->


        <!--    &lt;!&ndash; Cookies Start &ndash;&gt;-->
        <!--    <div class="card cookie-popup shadow rounded py-3 px-4">-->
        <!--        <p class="text-muted mb-0">This website uses cookies to provide you with a great user experience. By using it, you accept our <a href="https://shreethemes.in" target="_blank" class="text-success h6">use of cookies</a></p>-->
        <!--        <div class="cookie-popup-actions text-end">-->
        <!--            <button><i class="uil uil-times text-dark fs-4"></i></button>-->
        <!--        </div>-->
        <!--    </div>-->
        <!--    &lt;!&ndash;Note: Cookies Js including in plugins.init.js (path like; js/plugins.init.js) and Cookies css including in _helper.scss (path like; scss/_helper.scss)&ndash;&gt;-->
        <!--    &lt;!&ndash; Cookies End &ndash;&gt;-->

        <!-- Back to top -->
        <a href="#" onclick="topFunction()" id="back-to-top" class="back-to-top fs-5"><i data-feather="arrow-up" class="fea icon-sm icons align-middle"></i></a>
        <!-- Back to top -->

    </div>
</template>

<script>
export default {
    name: "app-layout",
    components: {
    },
    inject: ['auth'],
    props: {
        main: {
            // required: true
        },
        nav_type: {
            default: "nav-light"
        },
        footer_image: {
            default: true
        },
    },
    data() {
        return {
            // currentLocale: '',
            // main: [],
        }
    },
    async created() {

    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
    },
}
</script>
